import React, { useEffect, useState } from 'react'
import DataTable from "react-data-table-component";
import NcReportModal_1 from '../modal/NcReportModal_1';
import NcReportModal_2 from '../modal/NcReportModal_2';
import NcReportModal_3 from '../modal/NcReportModal_3';
import NcReportModal_4 from '../modal/NcReportModal_4';
import NewQualityCheck from '../modal/NewQualityCheck';
import NcReportView from '../modal/NcReportView'
import ReviewProductonHoldModal from '../modal/ReviewProductonHoldModal';
import InspectionReportModal from '../modal/InspectionReportModal';
import { formatDate } from "../../utils/formatDate";
import InspectionReportModalQuality from '../modal/InspectionReportModalQuality';
import config from "../../config/config";
import axios from "axios";
import { formatTime } from "../../utils/formatDate"
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
    },
  },
};
export default function QualityNc() {
  const [ncReport1, setNcReport1] = useState(false);
  const [ncReport2, setNcReport2] = useState(false);
  const [ncReport3, setNcReport3] = useState(false);
  const [ncReport4, setNcReport4] = useState(false);
  const [newQualityCheck, setNewQualityCheck] = useState(false);
  const [reviewProductonHold, setReviewProductonHold] = useState(false);
  const [inspectionReport, setInspectionReport] = useState(false);
  const [inspectionReportModalQuality, setInspectionReportModalQuality] = useState(false)
  const [ncReportView, setNcReportView] = useState(false)
  const [loading, setLoading] = useState(false);
  const [inspectionData, setInspectionData] = useState([]);
  const [qualityMetrics, setQualityMetrics] = useState([]);
  const [ncReports, setNcReports] = useState([])
  const [upcommingData, setUpcommingData] = useState([])
  const [quiltyData, setQuiltyData] = useState([])
  const [selectedId, setSelectedId] = useState(null);
  const [ncReportId, setNcReportId] = useState(null)
  const [productId, setProductId] = useState(null)
  const [qualityId, setQualityId] = useState(null)
  const [ncreportshistory, setNcreportshistory] = useState([])
  const fetchInspectionSummary = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/inspectionsummary`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = response?.data || {};
      setInspectionData(result)
    } catch (err) {
      console.error("Error fetching fetchInspectionSummary:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchQualityMetrics = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/qualitymetrics`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = response?.data || {};
      setQualityMetrics(result)
    } catch (err) {
      console.error("Error fetching fetchQualityMetrics:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchNcReports = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/ncreports`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setNcReports(response?.data?.nc_reports || []);
      } else {
        setNcReports([]);
      }
    } catch (err) {
      console.error("Error fetching fetchNcReports:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchNcReporthistory = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/ncreportshistory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setNcreportshistory(response?.data?.nc_report || []);
      } else {
        setNcreportshistory([]);
      }
    } catch (err) {
      console.error("Error fetching fetchNcReports:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchUpcommingList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/upcommingqualitychecks`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setUpcommingData(response?.data?.quality_issues_list || []);
      } else {
        setUpcommingData([]);
      }
    } catch (err) {
      console.error("Error fetching fetchUpcommingList:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchQualityCheckList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/qualitycheckhistory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setQuiltyData(response?.data?.quality_issues || []);
      } else {
        setQuiltyData([]);
      }

    } catch (err) {
      console.error("Error fetching fetchQualityCheckList:", err.message);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    fetchInspectionSummary()
    fetchQualityMetrics()
    fetchNcReports()
    fetchUpcommingList()
    fetchQualityCheckList()
    fetchNcReporthistory()
  }, [])

  const getBadge = (status, type) => {
    const colors = {
      New: "primary",
      Inprogress: "warning",
      Resolved: "success",
    };
    const color = colors[type] || "secondary";
    return (
      <span className={`badge bg-${color}-subtle text-${color} p-2`}>
        {status}
      </span>
    );
  };
  const handleReviewClick = (row) => {
    switch (row.status) {
      case "New":
        // setNcReport1(true);
        setNcReport2(true)
        break;
      case "Inprogress":
        setNcReport2(true)
        break;
      case "Resolved":
        setReviewProductonHold(true)
        break;
      default:
        break;
    }
  };

  const columns = [
    { name: "PRODUCT", selector: (row) => row?.product?.name, sortable: true, wrap: true, },
    {
      name: "MACHINE",
      cell: (row) =>
        row?.machine ? (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {row?.machine.name} ({row?.machine?.machine_code})
          </div>
        ) : "",
      sortable: true,
      wrap: true,
      grow: 2,
    },
    { name: "TYPE", selector: (row) => row.reason },
    {
      name: "Status",
      cell: (row) => getBadge(row.status, row.status),
    },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    { name: "Time", selector: (row) => formatTime(row.created_at), },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => { handleReviewClick(row); setProductId(row?.id) }}
        >
          Review
        </button>
      ),
    },
  ];

  const NcreportsHistory = [
    { name: "PRODUCT", selector: (row) => row?.product?.name, sortable: true, wrap: true, grow: 2 },
    {
      name: "MACHINE",
      cell: (row) =>
        row?.machine ? (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {row.machine.name} ({row.machine.machine_code})
          </div>
        ) : "",
      sortable: true,
      wrap: true,
      grow: 2,
    },
    { name: "TYPE", selector: (row) => row.reason },
    {
      name: "Status",
      cell: (row) => getBadge(row.status, row.status),
    },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    { name: "Time", selector: (row) => formatTime(row.created_at), },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => (setNcReportView(true), setNcReportId(row?.id))}
        >
          View Details
        </button>
      ),
    },
  ];

  const UpcommingGetBadge = (text, type) => {
    const colorMap = {
      new: "danger",
      inProcess: "warning",
      Pending: "warning",
      Approved: "primary",
      issued: "success"
    };

    const colorMaps = colorMap[type] || "secondary";

    return (
      <span className={`badge bg-${colorMaps}-subtle text-${colorMaps} p-2`}>
        {text}
      </span>
    );
  };

  const UpcommingColumns = [
    { name: "PRODUCT", selector: (row) => row?.product?.name, sortable: true, wrap: true, grow: 2 },
    { name: "TYPE", selector: (row) => row.check_type },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    { name: "Scheduled Time", selector: (row) => formatTime(row.created_at) },
    {
      name: "Status",
      cell: (row) => UpcommingGetBadge(row.status, row.status)
    },
    {
      name: "Actions",
      cell: (row) =>
        <button className="btn btn-outline-secondary btn-sm" style={{ whiteSpace: "nowrap" }} onClick={() => {
          setSelectedId(row.id);
          setInspectionReport(true);
        }}>
          Smart Check
        </button>
    }
  ];

  const QuiltyGetBadge = (text, type) => {
    const colorMap = {
      new: "danger",
      inProcess: "warning",
      pending: "warning",
      Approved: "success",
      issued: "success"
    };

    const colorMaps = colorMap[type] || "secondary";
    return (
      <span className={`badge bg-${colorMaps}-subtle text-${colorMaps} p-2`}>
        {text}
      </span>
    );
  };

  const QuiltyColumns = [
    {
      name: "PRODUCT",
      selector: (row) => row?.product?.name,
      sortable: true, wrap: true, grow: 2
    },
    {
      name: "QUANTITY",
      selector: (row) => row?.quantity_passed,
    },
    {
      name: "DATE",
      selector: (row) => row?.test_date,
    },
    {
      name: "RESULT",
      cell: (row) => QuiltyGetBadge(row?.status, row?.status)
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          style={{ whiteSpace: "nowrap" }}
          onClick={() => { setInspectionReportModalQuality(true); setQualityId(row?.id) }}
        >
          View Details
        </button>
      )
    }
  ];



  return (
    <div className='container-fluid'>
      <div className='row g-3'>
        <div className="col-md-6">
          <div className="card shadow-sm  h-100 font_family">
            <div className="card-body">
              <strong className="card-title fs-4">Inspection Summary</strong>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="d-flex justify-content-between my-2">
                    <span>In-Process Inspections</span>
                    <span className="badge bg-success-subtle text-dark p-2">{inspectionData.pending_inspection}</span>
                  </div>
                  <div className="d-flex justify-content-between my-2">
                    <span>Failed Inspections</span>
                    <span>{inspectionData.failed} ({inspectionData.rejected_inspection})</span>
                  </div>
                  <div className="d-flex justify-content-between my-2">
                    <span>Critical Issues</span>
                    <span>{1}</span>
                  </div>
                  <div className="d-flex justify-content-between my-2">
                    <span>Avg Resolution Time</span>
                    <span>{inspectionData.time ? Number(inspectionData.time).toFixed(2) : "0.00"}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <strong className="card-title fs-4">Quality Metrics</strong>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="mb-3" >
                    <div className="d-flex justify-content-between">
                      <span>First Pass Yield</span>
                      <span>{qualityMetrics.firstpass}%</span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className={`progress-bar bg-${qualityMetrics.color}`}
                        role="progressbar"
                        style={{ width: `${qualityMetrics.firstpass}%` }}
                      ></div>
                    </div>
                  </div>

                  <div className="mb-3" >
                    <div className="d-flex justify-content-between">
                      <span>Rework Rate</span>
                      <span>{qualityMetrics.rework}%</span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className={`progress-bar bg-${qualityMetrics.color}`}
                        role="progressbar"
                        style={{ width: `${qualityMetrics.rework}%` }}
                      ></div>
                    </div>
                  </div>

                  <div className="mb-3" >
                    <div className="d-flex justify-content-between">
                      <span>Scrap Rate</span>
                      <span>{qualityMetrics.scrap}%</span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className={`progress-bar bg-${qualityMetrics.color}`}
                        role="progressbar"
                        style={{ width: `${qualityMetrics.scrap}%` }}
                      ></div>
                    </div>
                  </div>

                  <div className="mb-3" >
                    <div className="d-flex justify-content-between">
                      <span>Visual Inspection Pass Rate</span>
                      <span>{qualityMetrics.visualpass}%</span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className={`progress-bar bg-${qualityMetrics.color}`}
                        role="progressbar"
                        style={{ width: `${qualityMetrics.visualpass}%` }}
                      ></div>
                    </div>
                  </div>
                </>
              )}


            </div>
          </div>
        </div>
      </div>
      <div className='row mt-4 m-1'>
        <div className='card p-3 font_family'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Nc Reports</strong>
            <button className="btn btn-dark" style={{ cursor: "pointer" }} onClick={() => setNcReport3(true)}>Log Manually</button>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={columns}
                data={ncReports}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
        </div>
      </div>
      <div className='row mt-4 m-1'>
        <div className='card p-3 font_family'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Nc Reports History</strong>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={NcreportsHistory}
                data={ncreportshistory}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
        </div>
      </div>
      <div className='row mt-4 m-1'>
        <div className='card p-3 font_family'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Upcomming Quality Checks </strong>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={UpcommingColumns}
                data={upcommingData}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
          <div className="text-center mt-3">
            <button className="btn btn-outline-dark w-100" onClick={() => setNewQualityCheck(true)}>
              + Schedule New Quality Check
            </button>
          </div>
        </div>
      </div>
      <div className='row mt-4 m-1'>
        <div className='card p-3 font_family'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Quality Check History</strong>
          </div>
          <DataTable
            columns={QuiltyColumns}
            data={quiltyData}
            customStyles={customStyles}
            responsive
            striped
            highlightOnHover
            pagination
          />
        </div>
      </div>
      {/* NcReportModal_1 */}
      <NcReportModal_1
        productId={productId}
        show={ncReport1}
        handleClose={() => setNcReport1(false)}
      />
      {/* NcReportModal_2 */}
      <NcReportModal_2
        productId={productId}
        show={ncReport2}
        refreshParent={() => {
          fetchNcReports();
          fetchNcReporthistory();
        }}
        handleClose={() => setNcReport2(false)}
      />
      {/* ReviewProductonHoldModal */}
      <ReviewProductonHoldModal
        show={reviewProductonHold}
        handleClose={() => setReviewProductonHold(false)}
      />
      {/* NcReportModal_3 */}
      <NcReportModal_3
        show={ncReport3}
        onNcReport={fetchNcReports}
        handleClose={() => setNcReport3(false)}
      />
      {/* NcReportModal_4 */}
      <NcReportModal_4
        show={ncReport4}
        handleClose={() => setNcReport4(false)}
      />
      {/* InspectionReportModal */}
      <InspectionReportModal
        show={inspectionReport}
        fetchUpcommingList={fetchUpcommingList}
        fetchQualityCheckList={fetchQualityCheckList}
        selectedId={selectedId}
        handleClose={() => setInspectionReport(false)}
      />
      {/* InspectionReportModal */}
      <NewQualityCheck
        show={newQualityCheck}
        onNewcheck={fetchUpcommingList}
        handleClose={() => setNewQualityCheck(false)}
      />
      {/* InspectionReportModalQuality */}
      <InspectionReportModalQuality
        qualityId={qualityId}
        show={inspectionReportModalQuality}
        handleClose={() => setInspectionReportModalQuality(false)}
      />
      <NcReportView
        ncReportId={ncReportId}
        show={ncReportView}
        handleClose={() => setNcReportView(false)}
      />
    </div>
  )
}
